export default __webpack_public_path__ + "4a10e379e20ce820fc2569a0604f9f0f.svg";